import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash-es';

import cn from 'classnames';

import SelectCommon from '../../../../CommonV2/Select';
import ButtonAction from '../ButtonAction';
import { ActionButtonEnum } from '../ButtonAction/ButtonAction.enum';

import { CSS_UID } from './SelectButtonBlock.utils';

import './SelectButtonBlock.scss';

const getValue = (options, currentValue) => {
  let opt;

  // Keep current is not disabled
  if (currentValue != null) {
    opt = find(options, { value: currentValue, isDisabled: false });

    if (opt) {
      return opt.value;
    }
  }

  // Get default not disabled
  opt = find(options, { default: true, isDisabled: false });

  if (opt) {
    return opt.value;
  }

  // If not, find first not disabled
  return find(options, option => !option.isDisabled)?.value;
};

/**
 * Select Button Block field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const SelectButtonBlock = ({ options, disabled, placeholder, label, eventEmitter }) => {
  const [valueLocal, setValueLocal] = useState(getValue(options));

  useEffect(() => {
    setValueLocal(getValue(options, valueLocal));
  }, [options]);

  return (
    <div className={cn(CSS_UID)}>
      {options ? (
        <SelectCommon
          field={{ name: 'selectButton', value: valueLocal }}
          selection={options}
          disabled={disabled}
          placeholder={placeholder}
          width="150px"
          minWidthMenu={null}
          eventEmitter={event => {
            setValueLocal(event);
          }}
        />
      ) : (
        <></>
      )}
      <ButtonAction
        typeAction={ActionButtonEnum.ADD}
        disabled={disabled}
        action={() => {
          eventEmitter(valueLocal);
        }}
        label={label}
        className={cn({ solo: !options })}
      />
    </div>
  );
};

SelectButtonBlock.propTypes = {
  options: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  eventEmitter: PropTypes.func.isRequired,
};

SelectButtonBlock.defaultProps = {
  options: undefined,
  disabled: false,
  placeholder: undefined,
  label: undefined,
};

export default SelectButtonBlock;
